import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const Click6NinjaW = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'click-6-w');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default Click6NinjaW;
